// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__195Nr","fullView":"styles_fullView__3Zf4J"};